<template>
  <b-container fluid class="no-sided-margin">
    <b-row class="margin-top-md margin-bottom-md">
      <b-col>
        <b-card header-bg-variant="light" style="margin-bottom: 50px">
          <template #header>
            <div style="height: 1.5rem">
              <span><strong><b-icon-book/> Utente </strong></span>
            </div>
          </template>
          <b-card-body>
            <b-table sticky-header="82vh" :no-border-collapse="true" responsive :fields="userDetail"
                     :items="customer" sort-by="ordinal_number">
              <template #cell(timestamp)="data">
                {{ asISODate(data.item.timestamp) }}
              </template>
            </b-table>
          </b-card-body>
        </b-card>
        <b-card header-bg-variant="light" style="margin-bottom: 50px">
          <template #header>
            <div style="height: 1.5rem">
              <span><strong><b-icon-book/> Tessera </strong></span>
            </div>
          </template>
          <b-card-body>
            <b-table sticky-header="82vh" :no-border-collapse="true" responsive :fields="cardDetail"
                     :items="card" sort-by="ordinal_number">
            </b-table>
          </b-card-body>
        </b-card>
        <b-card header-bg-variant="light">
          <template #header>
            <div style="height: 1.5rem">
              <span><strong><b-icon-book/> Storico </strong></span>
            </div>
          </template>
          <b-card-body>
            <b-table sticky-header="82vh" :no-border-collapse="true" responsive :fields="historyDetail"
                     :items="history" sort-by="ordinal_number">
              <template #cell(type)="data">
                <b-badge :variant="historyEntryTypeBadge(data.item.type)">{{
                    historyEntryTypeToString(data.item.type)
                  }}
                </b-badge>
              </template>
              <template #cell(timestamp)="data">
                {{ asISODate(data.item.timestamp) }}
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment/moment";
import eventBus from "@/EventBus";
import Sensei from "@/api/AutoshopApi";


export default {
  name: 'Customers',
  props: ['customerKey'],
  data: () => ({
    userDetail: [
      {key: "customerKey", label: "Codice cliente"},
      {key: "displayName", label: "Nome e Cognome"},
      {key: "fiscalCode", label: "Codice fiscale"},
      {key: "nation", label: "Nazione"},
      {key: "phoneNumber", label: "Numero di telefono"},
      {key: "email", label: "Email"},
      {key: "gender", label: "Sesso"},
      {key: "birthDate", label: "Data di nascita"},
      {key: "timestamp", label: 'Data'},
    ],
    cardDetail: [
      {key: "barcode", label: 'Tessera fidelity'},
      {key: "cardName", label: "Nome e Cognome fidelity"},
      {key: "status", label: 'Stato'}
    ],
    historyDetail: [
      {key: "timestamp", label: 'Data'},
      {key: "type", label: "Operazione"},
      {key: "displayName", label: "Nome e Cognome"},
      {key: "fiscalCode", label: "Codice fiscale"},
      {key: "nation", label: "Nazione"},
      {key: "phoneNumber", label: "Numero di telefono"},
      {key: "email", label: "Email"},
      {key: "gender", label: "Sesso"},
      {key: "birthDate", label: "Data di nascita"},
    ],
    customer: [],
    card: [],
    history: []
  }),
  mounted() {
    eventBus.$on('show-userDetails', (customer) => {
      this.customerKey = customer.customerKey
      this.fillCustomer()
    })

    this.fillCustomer()
  },
  methods: {
    fillCustomer() {
      if (this.customerKey !== undefined) {
        Sensei.findCustomerBy(this.customerKey)
          .then(response => {
            if (response.cardName === "null null") {
              response.cardName = null
            }
            let customer = new Array(response)
            this.customer = customer
            this.card = customer
          })
        Sensei.customerHistory(this.customerKey)
          .then(response => this.history = response)
      }
    },
    asISODate: date => moment(date).format('DD/MM/YYYY HH:mm'),
    historyEntryTypeToString: type => {
      switch (type) {
        case "REGISTER":
          return "Creazione"
        case "UPDATE":
          return "Modifica"
        case "UNREGISTER":
          return "Cancellazione"
        default:
          return "Sconosciuto"
      }
    },
    historyEntryTypeBadge: type => {
      switch (type) {
        case "REGISTER":
          return "success"
        case "UPDATE":
          return "info"
        case "UNREGISTER":
          return "danger"
        default:
          return "secondary"
      }
    },
  }
}
</script>
